<div
  class="edit-field-search-selector"
  [formGroup]="fieldParameters.sectionsContainer.formGroup"
>
  <ul class="edit-field-search-selector__selected-options">
    @if (fieldParameters.object[fieldParameters.field.name]) {
      <li class="edit-field-search-selector__selected-option bold">
        <span class="edit-field-search-selector__selected-option-text">
          <app-object-icon
            [object]="{artifact_id: fieldParameters.object[fieldParameters.field.name]}"
          ></app-object-icon>

          <span>
            {{fieldParameters.sectionsContainer.formGroup.controls[formControlName].value}}
          </span>
        </span>
      </li>
    }

    <li>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        [disabled]="disabled"
        (click)="clickEnableSelector()"
        (keydown)="($event.key === 'Enter') && clickEnableSelector()"
      >
        @if (!fieldParameters.object[fieldParameters.field.name]) {
          <span>
            <i class="icon-select1"></i>

            <span class="bold uppercase">
              {{ 'TRANS__FIELD__ARRAY_ADD' | translate }}
            </span>

            <span>&nbsp;</span>

            <span class="bold uppercase">
              {{fieldParameters.field.title | translate}}
            </span>
          </span>
        }
        @else {
          <span>
            <i class="icon-edit-alternative"></i>

            <span class="bold uppercase">
              {{ 'TRANS__FIELD__ARRAY_CHANGE' | translate }}
            </span>

            <span>&nbsp;</span>

            <span class="bold uppercase">
              {{fieldParameters.field.title | translate}}
            </span>
          </span>
        }
      </button>
    </li>
    @if (editFieldSearchSelectorContainer.reference.add_new_params?.can_add_new) {
      <li>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          [disabled]="disabled"
          (click)="openCreateNew()"
          (keydown)="($event.key === 'Enter') && openCreateNew()"
        >
          <i class="icon-create-new"></i>

          @if (!editFieldSearchSelectorContainer.reference?.add_new_params?.add_button_title) {
            <span class="bold uppercase">
              {{ 'TRANS__SEARCH_SELECTOR__CREATE_NEW' | translate }}
            </span>
            <span class="bold uppercase">
              {{ fieldParameters.field.title | translate }}
            </span>
          }
          @if (editFieldSearchSelectorContainer.reference?.add_new_params?.add_button_title) {
            <span class="bold uppercase">
              {{ editFieldSearchSelectorContainer.reference?.add_new_params?.add_button_title | translate }}
            </span>
          }
        </button>
      </li>
    }
    @if (editFieldSearchSelectorContainer.reference.search_kulturnav) {
      <li>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          [disabled]="disabled"
          (click)="searchKulturNav()"
          (keydown)="($event.key === 'Enter') && searchKulturNav()"
        >
          <mat-icon>
            get_app
          </mat-icon>

          <span class="bold uppercase">
            {{ 'TRANS__FIELD_SELECT__GET_FROM_AUTHORITY' | translate }}
          </span>
        </button>
      </li>
    }
  </ul>
</div>
